import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    headerImg: null,
    logo: null,
    isVideoPage: false,
    isReviewPage: false,
    isHome: false,
    isTrackPage: false,
    trackName: "",
    showSearchBar: false,
};
const layoutSlice = createSlice({
    name: "layout",
    initialState,
    reducers: {
        setHeaderImg: (state, action) => {
            state.headerImg = action.payload;
        },
        setLogo: (state, action) => {
            state.logo = action.payload;
        },
        setIsVideoPage: (state, action) => {
            state.isVideoPage = action.payload;
        },
        setIsReviewPage: (state, action) => {
            state.isReviewPage = action.payload;
        },
        setIsHome: (state, action) => {
            state.isHome = action.payload;
        },
        setIsTrackPage: (state, action) => {
            state.isTrackPage = action.payload;
        },
        setTrackName: (state, action) => {
            state.trackName = action.payload;
        },
    },
});

export const {
    setHeaderImg,
    setLogo,
    setIsVideoPage,
    setIsReviewPage,
    setIsHome,
    setIsTrackPage,
    setTrackName,
} = layoutSlice.actions;

export default layoutSlice.reducer;

export const showSearchBar = state => state.layout.isHome || state.layout.isTrackPage;
